import { render, staticRenderFns } from "./media-thumbnail.vue?vue&type=template&id=761a6b7c"
import script from "./media-thumbnail.vue?vue&type=script&lang=js"
export * from "./media-thumbnail.vue?vue&type=script&lang=js"
import style0 from "./media-thumbnail.vue?vue&type=style&index=0&id=761a6b7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports